import React from 'react';

import LoginComponent from 'components/Login';

const Login: React.FC = () => <LoginComponent />;

export default Login;
